<template>
    <div class='line' :class="{selectedLine: selectedLine}"  :data-word="charteObj.name" @click='$emit("selectLine")'  >
        <div class='col col1'>
            <a  @click='showCharte(charteObj.name)'  :title="'Consulter la charte '+ charteObj.name">{{ charteObj.name }}</a>
        </div>
        <!--<div class='col col2'>
            <input type="checkbox" :id="'chk_'+charteObj.name" :value="charteObj.name" @click='updateCharteState()' > <!- -:checked='charteObj.installed ? true : null'>- ->
        </div>-->
        
        
        <div class='col col3' v-if="isSuperAdmin()">
            <button id="btnDelete" class="mdl-button mdl-js-button mdl-button--icon btn_deletesub" :title="'Supprimer la charte '+charteObj.name" :data-dico="charteObj.name" @click='askDeleteCharte(charteObj.name)'><i class="material-icons">delete</i></button>
        </div>
        
        <button v-if="isSuperAdmin()" id="btnExport" class="mdl-button mdl-js-button mdl-button--icon" :title="'Télécharger la charte '+charteObj.name" :data-dico="charteObj.name" @click='downloadCharte(charteObj.name)'><i class="material-icons">file_download</i></button>
    </div> 
</template>

<script>
    import axios from 'axios'
    import FctUtils from '@/components/FctUtils';
    import { RoleEnum } from '../classes/enums'
    import { diagonalbackURL, defaultConfig, OctetStreamConfig } from "../constantes";

    export default { 
        name:"TypoLine",
        mixins: [FctUtils],
        props:{
            settingObj:{type:Object},
            charteObj: {type:Object},
            selectedLine:{type:Boolean},
        },
        methods:{
            isSuperAdmin(){
                return this.$store.state.currentUser.role == RoleEnum.SUPERADMIN.value;
            },
            showCharte(aDicoName) {
                // TODO
                /*this.$router.push({name:"DicoFrame", params: {
                    diconame: aDicoName, 
                    settingObjStr : JSON.stringify(this.settingObj)
                } });*/
            },
            askDeleteCharte() {
                this.emitter.emit('showPLForm', {mode:'formCharte_remove', data:this.charteObj});
            },
            updateCharteState() {
                /*var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/dictionaries/" + this.charteObj.name;

                const params = JSON.stringify( {'install' : ""+!this.charteObj.installed});

                axios.post(url, params, defaultConfig)
                .then(reponse => {
                    this.charteObj.installed = !this.charteObj.installed;

                    this.$store.dispatch('changeCompteur', this.$store.getters.compteur+1);
                })
                .catch(error => {
                    var aMsg = 'Echec lors de ';
                    if (!this.charteObj.installed) {
                        aMsg += 'l\'installation';
                    }
                    else {
                        aMsg += 'la mise en réserve'
                    }
                    aMsg += ' du dictionnaire '+ this.charteObj.name; 
                    
                    // on remet la checkbox dans le bon état
                    document.getElementById("chk_"+this.charteObj.name).checked = this.charteObj.installed;

                    alert(aMsg);
                });*/
            },
            downloadCharte(chartename) {
                var url = diagonalbackURL + "/settings/"+ this.settingObj.id + "/typography/chartes/" + chartename;

                axios(url, OctetStreamConfig)
                .then(response => {
                    this.downloadFile(chartename, response.data);
                })
                .catch(error => this.errorHandler(error));
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


#btnExport {
    position: absolute;
    top: 5px;
    right: 5px;
    color: #0075bb;
}



</style>
